// 九色爆料 · 单页门户演示数据（纯静态展示内容）

export const navLinks = [
  { key: "hot", label: "今日热榜", href: "#hot" },
  { key: "latest", label: "新瓜速递", href: "#latest" },
  { key: "trend", label: "热点盘点", href: "#trend" },
  { key: "topics", label: "话题分类", href: "#topics" },
  { key: "about", label: "平台口碑", href: "#about" },
  { key: "faq", label: "常见问题", href: "#faq" },
];

export const hotWords = [
  "新剧官宣",
  "综艺名场面",
  "颁奖季",
  "音乐节",
  "演唱会",
  "口碑剧集",
  "番外彩蛋",
  "影展红毯",
];

export const tickerItems = [
  "今日新增 12 条话题更新",
  "悬疑剧题材本周热度上涨",
  "音乐节现场话题冲上热榜",
  "多档新综艺官宣定档",
  "本周热点盘点已更新",
];

export const heroWords = [
  { label: "今日猛料", count: "48" },
  { label: "本周大瓜", count: "17" },
  { label: "热门话题", count: "96" },
];

export interface RankItem {
  rank: number;
  title: string;
  tag: string;
  heat: number;
  heatLabel: string;
  trend: "up" | "down" | "flat";
}

export const hotRanking: RankItem[] = [
  { rank: 1, title: "口碑古装剧持续升温，“慢节奏”叙事成新宠", tag: "影视", heat: 982, heatLabel: "98.2万", trend: "up" },
  { rank: 2, title: "演技类综艺回归，素人舞台频出高光名场面", tag: "综艺", heat: 941, heatLabel: "94.1万", trend: "up" },
  { rank: 3, title: "国产悬疑剧迎来小爆发，长线索追剧成热潮", tag: "影视", heat: 907, heatLabel: "90.7万", trend: "up" },
  { rank: 4, title: "多场大型音乐节扎堆定档，现场内容抢占话题榜", tag: "现场", heat: 856, heatLabel: "85.6万", trend: "up" },
  { rank: 5, title: "都市生活剧聚焦职场群像，金句频出引热议", tag: "影视", heat: 803, heatLabel: "80.3万", trend: "down" },
  { rank: 6, title: "颁奖季红毯造型盘点，造型师幕后花絮受关注", tag: "时尚", heat: 764, heatLabel: "76.4万", trend: "up" },
  { rank: 7, title: "纪录片聚焦青年返乡创业，温暖叙事获好评", tag: "行业", heat: 711, heatLabel: "71.1万", trend: "flat" },
  { rank: 8, title: "老牌综艺换代改版，新人主持能否接棒引讨论", tag: "综艺", heat: 668, heatLabel: "66.8万", trend: "down" },
  { rank: 9, title: "音乐厂牌官宣巡演计划，粉丝提前抢票忙", tag: "现场", heat: 602, heatLabel: "60.2万", trend: "up" },
  { rank: 10, title: "国产动画电影蓄势待发，幕后创作特辑受欢迎", tag: "行业", heat: 557, heatLabel: "55.7万", trend: "flat" },
];

export const feedTabs = ["全部", "影视", "综艺", "明星", "现场", "行业"];

export interface FeedItem {
  id: string;
  category: string;
  time: string;
  title: string;
  summary: string;
  view: string;
  comment: string;
}

export const latestFeeds: FeedItem[] = [
  { id: "f1", category: "影视", time: "刚刚", title: "悬疑长剧开启“解锁式”更新，追剧党迎来新体验", summary: "连续剧采用分阶段解锁更新的模式，让每一集的讨论时间拉长，观众在等待中也形成了新的剧情推演文化。", view: "12.3万", comment: "482" },
  { id: "f2", category: "现场", time: "12分钟前", title: "本周末音乐节全阵容曝光，早鸟票开售即告罄", summary: "多组乐队与新锐歌手同台，主办方公布的演出时间表成为歌迷热议焦点，二手票务话题也随之升温。", view: "9.8万", comment: "321" },
  { id: "f3", category: "综艺", time: "38分钟前", title: "演技综艺导师团亮相，犀利点评成为讨论热点", summary: "本期导师阵容兼顾学院派与实践派，选手首轮表演结束后，多条点评金句迅速登上热榜话题。", view: "15.1万", comment: "660" },
  { id: "f4", category: "明星", time: "1小时前", title: "多位艺人现身慈善晚宴，低调公益引发温暖点赞", summary: "晚宴现场多位艺人选择轻装出席，聚焦公益项目本身，低调务实的姿态获得网友一致好评。", view: "11.2万", comment: "298" },
  { id: "f5", category: "影视", time: "2小时前", title: "口碑古装剧释出角色番外短片，细节暗藏彩蛋", summary: "番外短片补充了主线之外的人物成长线，镜头语言和服化道细节被考据党逐帧分析，热度持续攀升。", view: "20.6万", comment: "905" },
  { id: "f6", category: "行业", time: "3小时前", title: "国产动画工作室公布新作企划，手绘预告获好评", summary: "工作室公开了全新动画电影的概念设定与手绘片段，扎实的美术功底与原创精神赢得观众期待。", view: "7.4万", comment: "187" },
  { id: "f7", category: "现场", time: "4小时前", title: "年度影展公布入围片单，华语作品备受关注", summary: "本届影展聚焦新人导演，多部华语长片入围主竞赛单元，评委会成员名单亦引发业内广泛讨论。", view: "13.7万", comment: "419" },
  { id: "f8", category: "综艺", time: "5小时前", title: "生活类慢综艺回归田园，真实烟火气引共鸣", summary: "节目不再刻意制造冲突，转而呈现主创与嘉宾真实的相处日常，治愈系风格收获稳定口碑。", view: "16.9万", comment: "743" },
  { id: "f9", category: "明星", time: "6小时前", title: "退役运动员跨界综艺，体育精神感染全场", summary: "节目邀请退役运动员分享训练与拼搏故事，朴实真诚的表达让现场与屏幕前的观众都为之动容。", view: "10.3万", comment: "356" },
  { id: "f10", category: "影视", time: "8小时前", title: "都市职场剧收官，开放式结局留足讨论空间", summary: "剧集以开放式结局收尾，主角职业选择的成长弧线引发观众对“理想与现实”的广泛热议。", view: "22.8万", comment: "1204" },
];

export interface TrendArticle {
  rank: number;
  tag: string;
  title: string;
  summary: string;
  image: string;
  reads: string;
}

export const trendArticles: TrendArticle[] = [
  {
    rank: 1,
    tag: "深度",
    title: "悬疑题材为何成近年最稳“流量密码”？",
    summary: "从强设定的钩子到连续性的追更节奏，悬疑剧找到了与观众互动最舒服的叙事方式。我们一起拆解爆款背后的结构与方法论。",
    image: "https://readdy.ai/api/search-image?query=cinematic%20dark%20red%20and%20amber%20moody%20editorial%20illustration%20of%20a%20film%20set%20with%20film%20reels%20and%20spotlight%20beam%2C%20warm%20dramatic%20lighting%2C%20mystery%20atmosphere%2C%20abstract%20artistic%20background&width=900&height=640&seq=trend-01&orientation=landscape",
    reads: "86万",
  },
  {
    rank: 2,
    tag: "趋势",
    title: "音乐节“扎堆热”背后：一场城市文化与年轻人的双向奔赴",
    summary: "演出阵容之外，音乐节正在变成城市名片与社交场景。门票经济之外，周边与餐饮消费同样撑起了一条完整产业链。",
    image: "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20an%20outdoor%20music%20festival%20crowd%20at%20sunset%20silhouettes%20with%20stage%20lights%20and%20confetti%2C%20warm%20amber%20and%20crimson%20tones%2C%20artistic%20energy&width=900&height=640&seq=trend-02&orientation=landscape",
    reads: "74万",
  },
  {
    rank: 3,
    tag: "观察",
    title: "慢综艺再回春：放下“冲突剧本”反而更动人",
    summary: "真实与松弛正在成为综艺叙事的新底色。当镜头不再追逐制造的矛盾，日常的烟火气反而带来了更长久的陪伴感。",
    image: "https://readdy.ai/api/search-image?query=warm%20cozy%20editorial%20illustration%20of%20a%20rustic%20countryside%20courtyard%20tea%20table%20with%20guests%20chatting%20in%20evening%20light%2C%20soft%20amber%20and%20terracotta%20palette%2C%20slow%20life%20atmosphere&width=900&height=640&seq=trend-03&orientation=landscape",
    reads: "61万",
  },
];

export interface TopicGroup {
  key: string;
  name: string;
  icon: string;
  desc: string;
  image: string;
  items: string[];
}

export const topicGroups: TopicGroup[] = [
  {
    key: "影视",
    name: "影视剧集",
    icon: "ri-movie-2-line",
    desc: "新剧定档、口碑剧集与热播剧讨论，追剧党的一站式片单参考。",
    image: "https://readdy.ai/api/search-image?query=warm%20cinematic%20editorial%20illustration%20of%20movie%20clapperboard%20and%20popcorn%20with%20soft%20red%20curtain%20backdrop%2C%20golden%20amber%20lighting%2C%20artistic%20composition&width=560&height=420&seq=topic-movie&orientation=landscape",
    items: ["本周口碑剧集榜", "新剧首播评测", "年度待播片单"],
  },
  {
    key: "综艺",
    name: "综艺综艺",
    icon: "ri-camera-3-line",
    desc: "从常驻阵容到舞台名场面，第一时间汇总综艺圈的热点话题。",
    image: "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20a%20bright%20stage%20with%20spotlights%20and%20confetti%20in%20warm%20amber%20and%20crimson%20tones%2C%20cheerful%20variety%20show%20atmosphere%2C%20artistic&width=560&height=420&seq=topic-show&orientation=landscape",
    items: ["综艺名场面盘点", "新节目首发预告", "高能选手档案"],
  },
  {
    key: "明星",
    name: "明星动态",
    icon: "ri-user-star-line",
    desc: "作品动态与公开活动资讯的客观汇总，关注作品也尊重台前幕后。",
    image: "https://readdy.ai/api/search-image?query=warm%20elegant%20editorial%20illustration%20of%20a%20glowing%20red%20carpet%20with%20soft%20golden%20lights%20and%20bokeh%2C%20celebrity%20silhouette%2C%20premiere%20atmosphere%2C%20artistic%20abstract&width=560&height=420&seq=topic-star&orientation=landscape",
    items: ["新作动态速览", "红毯造型回顾", "公益行动记录"],
  },
  {
    key: "现场",
    name: "现场演出",
    icon: "ri-music-2-line",
    desc: "演唱会、音乐节与剧场演出情报，开票信息与现场氛围一手掌握。",
    image: "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20a%20packed%20concert%20arena%20with%20lively%20stage%20lights%20in%20warm%20red%20and%20amber%20tones%2C%20energy%20and%20celebration%2C%20artistic&width=560&height=420&seq=topic-live&orientation=landscape",
    items: ["演唱会开票提醒", "音乐节阵容速览", "剧场演出推荐"],
  },
];

export const trustStats = [
  { value: "5000+", label: "累计聚合资讯" },
  { value: "24h", label: "全天滚动更新" },
  { value: "8个", label: "内容细分栏目" },
  { value: "0条", label: "未核实来源内容" },
];

export const principles = [
  { icon: "ri-verified-badge-line", title: "先核实，再发布", desc: "所有内容均优先采用权威媒体与公开信息源，来源不明或无法核实的内容一律不予收录。" },
  { icon: "ri-eye-line", title: "客观不煽动", desc: "描述力求中性克制，不夸大、不渲染，不传播针对个人的未经证实信息。" },
  { icon: "ri-community-line", title: "尊重创作者", desc: "关注作品与公开动态，尊重每一位台前幕后创作者的努力与付出。" },
  { icon: "ri-time-line", title: "滚动更新", desc: "采用编辑值班制度，全天候滚动聚合最新、最重要的娱乐资讯与行业动态。" },
];

export const testimonials = [
  { quote: "信息聚合得很清爽，热榜和分类一目了然，午休刷一刷就能跟上周边的讨论。", author: "追剧爱好者 · 小鹿", tag: "影视" },
  { quote: "想看演出和音乐节的信息，这里把开票与阵容整理得很清楚，很少漏掉重点。", author: "现场党 · 阿凯", tag: "现场" },
  { quote: "内容风格克制客观，没有乱七八糟的标题党，读起来舒服，也愿意长期关注。", author: "资深观众 · 老周", tag: "观察" },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  { q: "九色爆料的内容来源是什么？", a: "我们主要聚合官方媒体、行业资讯与公开的活动信息，并配有专门的内容编辑进行核实与筛选。来源不明或无法确认的内容不会被收录发布。" },
  { q: "网站的资讯多久更新一次？", a: "内容团队采用全天滚动更新的方式，重点栏目（今日热榜、新瓜速递）通常在热点出现后的第一时间内完成整理并上线。" },
  { q: "你们如何保证不传播虚假信息？", a: "我们有“来源不明一律不收”的底线原则，并建立了多层人工复核流程。若发现个别信息有误，也会第一时间在页面内进行修正与说明。" },
  { q: "我看到了不错的线索或作品，可以投稿吗？", a: "当然可以。欢迎通过页面底部的投稿与联系表单提供线索或作品资讯，编辑核实后会择优收录并标注来源。" },
  { q: "是否支持商业合作与授权转载？", a: "支持。品牌合作、专栏共建与内容转载授权均可通过联系我们页面的商务邮箱沟通，我们会在核实后给出明确答复。" },
];

export const footerTopics = [
  { label: "影视剧集", href: "#topics" },
  { label: "综艺综艺", href: "#topics" },
  { label: "明星动态", href: "#topics" },
  { label: "现场演出", href: "#topics" },
  { label: "行业观察", href: "#topics" },
];

export const footerQuick = [
  { label: "今日热榜", href: "#hot" },
  { label: "新瓜速递", href: "#latest" },
  { label: "热点盘点", href: "#trend" },
  { label: "平台口碑", href: "#about" },
  { label: "常见问题", href: "#faq" },
];